// src/modules/maintenance/contexts/MechanicAuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';

const MechanicAuthContext = createContext();

export const useMechanicAuth = () => useContext(MechanicAuthContext);

// The key we'll use in session storage
const STORAGE_KEY = 'mechanic_auth';

export const MechanicAuthProvider = ({ children }) => {
  // We initialize the state by reading from sessionStorage
  const [mechanic, setMechanic] = useState(() => {
    try {
      const storedItem = sessionStorage.getItem(STORAGE_KEY);
      if (storedItem) {
        return JSON.parse(storedItem);
      }
    } catch (error) {
      console.error("Error reading from sessionStorage", error);
    }
    return null; // Default to null if nothing is stored
  });

  // This effect will run ONLY when the 'mechanic' state changes
  // It keeps sessionStorage in sync with our React state
  useEffect(() => {
    try {
      if (mechanic) {
        // Save the logged-in mechanic to storage
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(mechanic));
      } else {
        // Remove the mechanic from storage on logout
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      console.error("Error writing to sessionStorage", error);
    }
  }, [mechanic]); // Dependency array: only run when 'mechanic' changes

  const loginMechanic = (mechanicData) => {
    setMechanic(mechanicData); // This will trigger the useEffect to save
  };

  const logoutMechanic = () => {
    setMechanic(null); // This will trigger the useEffect to clear
  };

  const value = {
    mechanic,
    isMechanicLoggedIn: !!mechanic,
    loginMechanic,
    logoutMechanic,
  };

  return (
    <MechanicAuthContext.Provider value={value}>
      {children}
    </MechanicAuthContext.Provider>
  );
};